package com.evoapps.evoshift.domain.usecase.settings

import com.evoapps.evoshift.domain.model.WorkplaceFinancials
import com.evoapps.evoshift.domain.repository.WorkplaceRepository
import kotlinx.datetime.DayOfWeek

/**
 * Saves a workplace's weekly sales plan (onboarding, SH-61): the other financial settings are kept,
 * the targets are replaced. Keys are the full lowercase day names the daily records read
 * ([WorkplaceFinancials.salesTargetKey]); anything else is refused.
 */
class SaveSalesTargetsUseCase(private val repository: WorkplaceRepository) {
    suspend operator fun invoke(workplaceId: String, targets: Map<String, Double>): Result<Unit> = runCatching {
        val keys = DayOfWeek.entries.map(WorkplaceFinancials::salesTargetKey).toSet()
        require(targets.keys.all { it in keys }) { "Sales targets are keyed by day name: ${targets.keys - keys}" }
        require(targets.values.all { it >= 0.0 }) { "Sales targets cannot be negative" }
        val current = repository.getWorkplaceFinancials(workplaceId).getOrThrow()
        repository.updateWorkplaceFinancials(workplaceId, current.copy(salesTargets = targets)).getOrThrow()
    }
}
